import { SelectItem, OverlayPanel } from 'primeng/primeng';
import { EntityDetailsService } from './../../../entities/details/entity-details.service';
import { EntityRelationsService } from './../../../entities/relations/entity-relations.service';
import { relationListLimit, relationsNamed } from 'app/entities/relations/relation-list.util';
import { ConstantsService } from './../../../services/constants-service';
import { MdDialogRef } from '@angular/material';
import { EntityRelation } from 'app/shared/models/entity-relation.model';
import { EntityIdDetails } from './../../models/entity-id-details.model';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'relation-drop-down',
  templateUrl: './relation-drop-down.component.html',
  styleUrls: ['./relation-drop-down.component.css']
})
export class RelationDropDownComponent implements OnInit {

  entityIdDetails: EntityIdDetails;
  relationships: EntityRelation[] = [];
  allRelationships: EntityRelation[] = []; // Store all relationships for filtering
  reverseRelationshipDetails: EntityRelation[] = []; // Initialize to empty array
  allReverseRelationshipDetails: EntityRelation[] = []; // Store all reverse relationships for filtering
  filteredRelationships: EntityRelation[] = [];
  filteredReverseRelationships: EntityRelation[] = [];
  searchFilter: string = '';
  numberOfRelationship = 0;
  selectedTab = 0;
  dialogRef: MdDialogRef<any>;
  isLoading: boolean;
  expend: any;
  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  orgLogo = ConstantsService.DEFAULT_ORG_LOGO;
  maxRecordsToBeDisplayed = 10;
  currentRelationShipRecords = 0;
  isRecordNumberMoreThanLimit: Boolean;
  @Input() showRelation: any;
  @Output() selectedEntityRelation: EventEmitter<EntityRelation> = new EventEmitter();
  constructor(public entityRelationsService: EntityRelationsService,
    private entityDetailsService: EntityDetailsService, ) { }

  ngOnInit() {
    // Initialize filtered arrays
    this.filteredRelationships = [];
    this.filteredReverseRelationships = [];
    
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    if (this.entityIdDetails.entityId) {
      this.loadRelationships();
      this.loadReverseRelationship();
    } else {
      this.entityDetailsService.entityDetailsUpdated.subscribe(
        (entityDetails) => {
          this.entityIdDetails = entityDetails;
          this.loadRelationships();
          this.loadReverseRelationship();
        }
      );
    }
  }

  public loadRelationships() {
    this.fetchRelationPage(0, relationListLimit(0), true);
  }

  private fetchRelationPage(offset: number, limit: number, replace: boolean) {
    this.isLoading = true;
    this.entityRelationsService.getRelationshipsWithOffsetAndLimits(this.entityIdDetails.entityId,
      offset, limit).subscribe(
        response => {
          const rows = (response && response.arrResult && response.arrResult.relations) || [];
          const total = (response && response.arrResult && response.arrResult.totalRecords) || rows.length;
          this.allRelationships = replace ? rows : this.allRelationships.concat(rows);
          this.relationships = this.allRelationships;
          this.numberOfRelationship = total;
          this.isRecordNumberMoreThanLimit = total > this.maxRecordsToBeDisplayed;
          if (rows.length > 0 && this.allRelationships.length < total) {
            const remaining = total - this.allRelationships.length;
            this.fetchRelationPage(this.allRelationships.length, relationListLimit(remaining), false);
            return;
          }
          this.isLoading = false;
          this.applyFilter();
        },
        error => {
          this.isLoading = false;
          if (replace) {
            this.relationships = [];
            this.allRelationships = [];
            this.numberOfRelationship = 0;
            this.isRecordNumberMoreThanLimit = false;
          }
          this.applyFilter();
        });
  }

  public loadReverseRelationship() {
    this.entityRelationsService.loadReverseRelationshipDetails(this.entityIdDetails.entityId).subscribe(
      response => {
        if (response && response.arrResult) {
          this.reverseRelationshipDetails = response.arrResult || [];
          this.allReverseRelationshipDetails = response.arrResult || [];
        } else {
          this.reverseRelationshipDetails = [];
          this.allReverseRelationshipDetails = [];
        }
        this.applyFilter();
      },
      error => {
        this.reverseRelationshipDetails = [];
        this.allReverseRelationshipDetails = [];
        this.applyFilter();
      });
  }

  onSearchChange(searchValue: string) {
    this.searchFilter = (searchValue || '').toLowerCase().trim();
    this.applyFilter();
  }

  applyFilter() {
    if (!this.searchFilter) {
      this.filteredRelationships = this.allRelationships || [];
      this.filteredReverseRelationships = this.allReverseRelationshipDetails || [];
    } else {
      this.filteredRelationships = relationsNamed(this.allRelationships, this.searchFilter);
      this.filteredReverseRelationships = relationsNamed(this.allReverseRelationshipDetails, this.searchFilter);
    }
  }

  onScrollDown() {
    if (this.allRelationships.length < this.numberOfRelationship) {
      this.fetchRelationPage(this.allRelationships.length,
        relationListLimit(this.numberOfRelationship - this.allRelationships.length), false);
    }
  }

  select(relation: EntityRelation) {
    console.log('=== RelationDropDownComponent.select CALLED ===');
    console.log('Selected relation:', relation);
    console.log('Relation name:', relation ? relation.name : 'null');
    console.log('Relation entityId:', relation ? relation.entityId : 'null');
    
    if (!relation) {
      console.error('ERROR: relation is null in select method!');
      return;
    }
    
    this.searchFilter = ''; // Clear search filter when selecting
    this.applyFilter(); // Reset filtered lists
    
    console.log('Emitting selectedEntityRelation event');
    this.selectedEntityRelation.emit(relation);
    console.log('=== RelationDropDownComponent.select COMPLETE ===');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/relation-drop-down/relation-drop-down.component.ts